<section class="container-style">
  <form [formGroup]="formUserUpdatePassword" autocomplete="off">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-4 col-6 mb-1">
        <app-custom-input-password formControlName="passwordHash" [labelText]="'Nueva Contraseña'" [required]="true"
          [appendTo]="'body'"></app-custom-input-password>
      </div>
      <div class="col-lg-12 col-md-12 col-sm-4 col-6">
        <app-custom-input-password formControlName="confirmPasswordHash" [labelText]="'Confirmar Nueva Contraseña'"
          [required]="true" [appendTo]="'body'"></app-custom-input-password>
      </div>
      <div class="col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-end align-items-end mt-sm-2 mt-md-3">
        <app-custom-button [label]="'Actualizar'" [severity]="'primary'" [variant]="undefined"
          (onClick)="send()"></app-custom-button>
      </div>
    </div>
  </form>
</section>